const customerUpdateMeQuery = require('../../queries/user/customerUpdateMeQuery');
const { clientMutate } = require('../queries');
const handleCtApiError = require('../handleCtApiError');

const addShippingAddress = async (context, currentUser, address, customQuery) => {
  const addressKey = `${address.postalCode}-${Date.now()}`;
  const addressWithKey = {
    ...address,
    key: addressKey,
  };
  const defaultVariables = {
    version: currentUser.version,
    actions: [{
      addAddress: { address },
    }],
  };
  const { addShippingAddress } = context.extendQuery(customQuery, {
    addShippingAddress: {
      query: customerUpdateMeQuery,
      variables: defaultVariables,
    },
  });
  const actions = [
    {
      addAddress: {
        address: addressWithKey,
      },
    },
    {
      addShippingAddressId: {
        addressKey,
      },
    },
  ];
  const options = {
    mutation: addShippingAddress.query,
    variables: {
      version: currentUser.version,
      actions,
    },
    fetchPolicy: 'no-cache',
  };
  try {
    const updateResponse = await clientMutate(context, options);

    return updateResponse;
  } catch (error) {
    throw handleCtApiError(error);
  }
};

module.exports = addShippingAddress;
